import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { calculateTotal, calculateSubtotal } from '../data/mockData';

const FloatingCheckoutButton = ({ cart, onClick, branding }) => {
  const itemCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const total = calculateTotal(cart);
  
  // Use dark blue for the white theme
  const buttonColor = "#0a1628";

  if (itemCount === 0) return null;

  return (
    <button
      onClick={onClick}
      className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-40 group"
      style={{ pointerEvents: 'auto' }}
      data-testid="floating-checkout-btn"
    >
      {/* Outer glow ring */}
      <div 
        className="absolute inset-0 rounded-full blur-lg opacity-30 group-hover:opacity-50 transition-opacity animate-pulse" 
        style={{ 
          transform: 'scale(1.2)',
          backgroundColor: buttonColor,
        }} 
      />
      
      {/* Main button */}
      <div 
        className="relative w-28 h-28 rounded-full shadow-2xl flex flex-col items-center justify-center text-white bg-[#0a1628] transition-all duration-300 group-hover:scale-110"
      >
        {/* Cart icon or custom image */}
        {branding?.cart_icon_url ? (
          <img 
            src={branding.cart_icon_url} 
            alt="Cart" 
            className="w-10 h-10 mb-1 object-contain"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'block';
            }}
          />
        ) : null}
        <ShoppingCart 
          className={`w-8 h-8 mb-1 ${branding?.cart_icon_url ? 'hidden' : ''}`}
        />
        
        {/* Item count badge */}
        <div className="absolute -top-1 -right-1 w-8 h-8 bg-white rounded-full flex items-center justify-center text-[#0a1628] font-bold text-sm shadow-lg border-2 border-[#0a1628]">
          {itemCount > 99 ? '99+' : itemCount}
        </div>
        
        {/* Total amount */}
        <span className="text-xs font-medium opacity-80">Checkout</span>
        <span className="text-sm font-bold">${total.toFixed(2)}</span>
      </div>

      {/* Ripple effect on hover */}
      <div 
        className="absolute inset-0 rounded-full border-4 border-[#0a1628] opacity-0 group-hover:opacity-100 group-hover:scale-150 transition-all duration-500" 
      />
    </button>
  );
};

export default FloatingCheckoutButton;
